export const SHOWFINANCEDIALOG = 'SHOWFINANCEDIALOG'
export const HIDEDIALOG = 'HIDEDIALOG'
export const SHOWSALESDIALOG = 'SHOWSALESDIALOG'
export const CODATCONNECTED = 'CODATCONNECTED'
export const CODATDISCONNECTED = 'CODATDISCONNECTED'
export const COMMERCECODATCONNECTED = 'COMMERCECODATCONNECTED'
export const ACCOUNTINGCODATCONNECTED = 'ACCOUNTINGCODATCONNECTED'
export const COMMERCECONNECTIONID = 'COMMERCECONNECTIONID'
export const ACCOUNTINGCONNECTIONID = 'ACCOUNTINGCONNECTIONID'
export const COMMERCECODATDISCONNECTED = 'COMMERCECODATDISCONNECTED'
export const ACCOUNTCODATDISCONNECTED = 'ACCOUNTCODATDISCONNECTED'

export const SETDEFAULTBUSINESSID = 'SETDEFAULTBUSINESSID'
export const RESETSALESDATA = 'RESETSALESDATA'
export const CASHFLOWDATAFETCHED = 'CASHFLOWDATAFETCHED'
export const CASHFLOWCHARTDATAFETCHED = 'CASHFLOWCHARTDATAFETCHED'
export const TOGGLESUBSCRIPTIONMODAL = 'TOGGLESUBSCRIPTIONMODAL'
export const TOGGLECOMPANYNAMEMODAL = 'TOGGLECOMPANYNAMEMODAL'
export const SUMMARYCASHFLOWDATA = 'SUMMARYCASHFLOWDATA'
export const CASHFLOWTABLEDATAFETCHED = 'CASHFLOWTABLEDATAFETCHED'

export const PAYABLESDATAFETCHED = 'PAYABLESDATAFETCHED'
export const PAYABLESTABLEDATAFETCHED = 'PAYABLESTABLEDATAFETCHED'
export const PAYABLESCHARTDATAFETCHED = 'PAYABLESCHARTDATAFETCHED'
export const UNPAIDBILLSDATAFETCHED = 'UNPAIDBILLSDATAFETCHED'
export const PAIDBILLSDATAFETCHED = 'PAIDBILLSDATAFETCHED'
export const RECEIVABLESDATAFETCHED = 'RECEIVABLESDATAFETCHED'
export const RECEIVABLESCHARTDATAFETCHED = 'RECEIVABLESCHARTDATAFETCHED'
export const RECEIVABLESTABLEDATAFETCHED = 'RECEIVABLESTABLEDATAFETCHED'
export const UNPAIDINVOICESDATAFETCHED = 'UNPAIDINVOICESDATAFETCHED'
export const PAIDINVOICESDATAFETCHED = 'PAIDINVOICESDATAFETCHED'

export const USERDATAFETCHED = 'USERDATAFETCHED'
export const BUSINESSDATAFETCHED = 'BUSINESSDATAFETCHED'

export const SETLOADINGCASHFLOWDATA = 'SETLOADINGCASHFLOWDATA'
export const SETLOADINGCASHFLOWCHARTDATA = 'SETLOADINGCASHFLOWCHARTDATA'
export const SETLOADINGCASHFLOWTABLEDATA = 'SETLOADINGCASHFLOWTABLEDATA'
export const SETLOADINGPAYABLESDATA = 'SETLOADINGPAYABLESDATA'
export const SETLOADINGPAYABLESCHARTDATA = 'SETLOADINGPAYABLESCHARTDATA'
export const SETLOADINGPAYABLESTABLEDATA = 'SETLOADINGPAYABLESTABLEDATA'
export const SETLOADINGUNPAIDBILLSDATA = 'SETLOADINGUNPAIDBILLSDATA'
export const SETLOADINGPAIDBILLSDATA = 'SETLOADINGPAIDBILLSDATA'
export const SETLOADINGRECEIVABLESDATA = 'SETLOADINGRECEIVABLESDATA'
export const SETLOADINGRECEIVABLESCHARTDATA = 'SETLOADINGRECEIVABLESCHARTDATA'
export const SETLOADINGRECEIVABLESTABLEDATA = 'SETLOADINGRECEIVABLESTABLEDATA'
export const SETLOADINGUNPAIDINVOICESDATA = 'SETLOADINGUNPAIDINVOICESDATA'
export const SETLOADINGPAIDINVOICESDATA = 'SETLOADINGPAIDINVOICESDATA'

export const LOADINGTRANSACTIONTABLEDATA = 'LOADINGTRANSACTIONTABLEDATA'
export const LOADINGDISPUTETABLEDATA = 'LOADINGDISPUTETABLEDATA'
export const LOADINGSALEVOLUMETABLEDATA = 'LOADINGSALEVOLUMEDATA'

// Filter options
export const CASHFLOW_TRX_TYPES_FILTERS_FETCHED = 'CASHFLOW_TRX_TYPES_FILTERS_FETCHED'
export const PAYABLE_BILL_STATUS_FILTERS_FETCHED = 'PAYABLE_BILL_STATUS_FILTERS_FETCHED'
export const RECEIVABLE_INVOICE_STATUS_FILTERS_FETCHED = 'RECEIVABLE_INVOICE_STATUS_FILTERS_FETCHED'
export const DISPUTE_PAYMENT_STATUS_FILTERS_FETCHED = 'DISPUTE_PAYMENT_STATUS_FILTERS_FETCHED'
export const TRANSACTION_PAYMENT_METHOD_FILTERS_FETCHED = 'TRANSACTION_PAYMENT_METHOD_FILTERS_FETCHED'
export const TRANSACTION_PAYMENT_STATUS_FILTERS_FETCHED = 'TRANSACTION_PAYMENT_STATUS_FILTERS_FETCHED'
export const TRANSACTION_TYPES_FILTERS_FETCHED = 'TRANSACTION_TYPES_FILTERS_FETCHED'
export const RECEIVABLE_INVOICE_TABLE_STATUS_FETCHED = 'RECEIVABLE_INVOICE_TABLE_STATUS_FETCHED'
export const PAYABLE_BILL_TABLE_STATUS_FETCHED = 'PAYABLE_BILL_TABLE_STATUS_FETCHED'

export const SHOWERRORNOTIFICATION = 'SHOWERRORNOTIFICATION'
export const HIDEERRORNOTIFICATION = 'HIDEERRORNOTIFICATION'

export const SETFINANCIALOVERVIEWDAYSPAN = 'SETFINANCIALOVERVIEWDAYSPAN'

export const RESETPAGENOFORTABLE = 'RESETPAGENOFORTABLE'

export const SETCOMPANYID = 'SETCOMPANYID'

export const SETERRORSTATE = 'SETERRORSTATE'

export const DASHBOARD_INFO_FETCHED = 'DASHBOARD_INFO_FETCHED'

export const CODAT_INTEGRATED = 'CODAT_INTEGRATED'

export const SETPAYABLESSUMMARY = 'SETPAYABLESSUMMARY'

export const SETRECEIVABLESSUMMARY = 'SETRECEIVABLESSUMMARY'

export const RESET_APP_STATE = 'RESET_APP_STATE'
export const RESET_SALES_STATE = 'RESET_SALES_STATE'
export const RESET_USER_STATE = 'RESET_USER_STATE'
export const RESET_VAULT_STATE = 'RESET_VAULT_STATE'

export const EMAILTOVERIFY = 'EMAILTOVERIFY'
export const EMAILDETAIL = 'EMAILDETAIL'
